module.exports = {
  "country": "AL",
  "artist": "Jonida Maliqi",
  "song": "Ktheju tokës",
  "year": "2019",
  "place": "17",
  "spotify": "26RpGVUL6YDxYcLSz9k3eX"
};